import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getOrderDetails, payOrder } from "../redux/Actions/OrderActions";
import {
  ORDER_PAY_RESET
} from "../redux/Constants/OrderConstants";
import Header from "./../components/Header";
import Message from "./../components/LoadingError/Error";
import Loading from "./../components/LoadingError/Loading";
import { domainIp, formatNumber, rateUsdt } from "../service";
import VietQRImage from "../lib/VietQRImage";
import VietQRGenerator from "../lib/vietQR";
import { BiUser } from "react-icons/bi";
import { CiDeliveryTruck } from "react-icons/ci";
import { FaMapLocationDot } from "react-icons/fa6";

// ... imports giữ nguyên

const OrderScreen = ({ match }) => {
  window.scrollTo(0, 0);
  const [sdkReady, setSdkReady] = useState(false);

  const orderId = match.params.id;
  const dispatch = useDispatch();

  const orderDetails = useSelector((state) => state.orderDetails);
  const { order, loading, error } = orderDetails;
  console.log(order);
  // if (!order) {
  //   return
  // }

  const orderPay = useSelector((state) => state.orderPay);
  const { loading: loadingPay, success: successPay } = orderPay;

  if (!loading && order) {
    const addDecimals = (num) => {
      return (Math.round(num * 100) / 100).toFixed(2);
    };
    // if (!order) {
    //   return
    // }
    order.itemsPrice = addDecimals(
      order.orderItems?.reduce((acc, item) => acc + item.price * item.qty, 0)
    );
    order.itemsPriceToken = addDecimals(
      order.orderItems?.reduce((acc, item) => acc + item.priceToken * item.qty, 0)
    );
  }

  useEffect(() => {
    const addPayPalScript = async () => {
      const { data: clientId } = await axios.get(`${domainIp}/api/config/paypal`);
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}`;
      script.async = true;
      script.onload = () => {
        setSdkReady(true);
      };
      document.body.appendChild(script);
    };

    if (!order || successPay) {
      dispatch({ type: ORDER_PAY_RESET });
      dispatch(getOrderDetails(orderId));
    } else if (!order.isPaid) {
      if (!window.paypal) {
        addPayPalScript();
      } else {
        setSdkReady(true);
      }
    }
  }, [dispatch, orderId, successPay, order]);

  const successPaymentHandler = (paymentResult) => {
    dispatch(payOrder(orderId, paymentResult));
  };
  // console.log(order);

  return (
    <div className="w-full flex justify-center items-center mt-8">
      <div className="w-[--page-width] p-4">
        {loading ? (
          <Loading />
        ) : error ? (
          <Message variant="alert-danger">{error}</Message>
        ) : (
          <>
            {/* 3 ô thông tin */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              {/* 1. Khách hàng */}
              <div className="grid grid-cols-6 items-center gap-4 bg-white shadow rounded-lg p-4">

                <div className="col-span-2 md:col-span-1   flex items-center justify-center">
                  <div className="bg-green-100 text-green-600 rounded-full w-[50px] h-[50px] items-center justify-center flex">     <BiUser /></div>

                </div>
                <div className="col-span-4 md:col-span-5">
                  <h5 className="font-semibold">Khách hàng</h5>
                  <p className="text-sm">{order?.user?.name}</p>
                  <p className="text-sm">
                    <a href={`mailto:${order?.user?.email}`} className="text-blue-600 hover:underline">
                      {order?.user?.email}
                    </a>
                  </p>
                </div>
              </div>

              {/* 2. Thông tin đơn hàng */}
              <div className="grid grid-cols-6 gap-4 items-center justify-center bg-white shadow rounded-lg p-4">
                <div className="col-span-2 md:col-span-1 flex items-center justify-center">
                  <div className="bg-green-100 text-green-600 rounded-full w-[50px] h-[50px] items-center justify-center flex">     <CiDeliveryTruck /></div>

                </div>

                <div className="col-span-4 md:col-span-5">
                  <h5 className="font-semibold">Thông tin đơn hàng</h5>
                  <p className="text-sm">Giao hàng: {order?.shippingAddress.country}</p>
                  <p className="text-sm">
                    Thanh toán:{" "}
                    {order?.paymentMethod === "now"
                      ? "Online"
                      : order?.paymentMethod === "point"
                        ? "Điểm"
                        : "Khi nhận hàng"}
                  </p>
                  {order?.isPaid ? (
                    <div className="bg-blue-500 text-white text-sm px-2 py-1 rounded mt-1">
                      Đã thanh toán lúc {moment(order?.paidAt).calendar()}
                    </div>
                  ) : (
                    <div className="bg-red-500 text-white text-sm px-2 py-1 rounded mt-1">
                      Chưa thanh toán
                    </div>
                  )}
                </div>
              </div>

              {/* 3. Địa chỉ giao hàng */}
              <div className="grid grid-cols-6 bg-white shadow rounded-lg p-4">
                <div className="col-span-2 md:col-span-1  flex items-center justify-center">
                  <div className="bg-green-100 text-green-600 rounded-full w-[50px] h-[50px] items-center justify-center flex">   <FaMapLocationDot /></div>

                </div>
                <div className="col-span-4 md:col-span-5">
                  <h5 className="font-semibold">Giao tới</h5>
                  <p className="text-sm">Địa chỉ: {order?.shippingAddress?.address}</p>
                  <p className="text-sm">Sđt: {order?.shippingAddress?.city}</p>
                  {order?.isDelivered ? (
                    <div className="bg-blue-500 text-white text-sm px-2 py-1 rounded mt-1">
                      Đã giao lúc {moment(order?.deliveredAt).calendar()}
                    </div>
                  ) : (
                    <div className="bg-red-500 text-white text-sm px-2 py-1 rounded mt-1">
                      Chưa giao hàng
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Danh sách sản phẩm + tổng tiền */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
              {/* Sản phẩm */}
              <div className="lg:col-span-8 space-y-4">
                {order?.orderItems?.length === 0 ? (
                  <Message variant="alert-info mt-5">Đơn hàng trống</Message>
                ) : (
                  order?.orderItems?.map((item, index) => (
                    <div
                      className="grid grid-cols-12 gap-4 items-center bg-white p-4 rounded-lg shadow"
                      key={index}
                    >
                      <div className="col-span-2">
                        <img src={item?.image?.url} alt={item?.name} className="rounded-lg w-[100px] h-[100px] object-contain" />
                      </div>
                      <div className="col-span-3 md:col-span-6">
                        <Link to={`/products/${item?.product}`} className="font-medium line-clamp-2 text-sm text-gray-800 hover:text-blue-600">
                          {item?.name}
                        </Link>
                      </div>
                      <div className="col-span-3  md:col-span-2 text-center">
                        <p className="text-xs md:text-sm font-semibold ">Số lượng</p>
                        <p>{item?.qty}</p>
                      </div>
                      <div className="col-span-4 md:col-span-2 text-right">
                        <p className="text-xs md:text-sm  font-semibold">Tạm tính</p>
                        <p className="flex items-center justify-end gap-1 text-sm">
                          <img src="/images/logoToken.png" className="w-5" />
                          {formatNumber(item?.qty * item?.price)}{" "}
                          <span className="text-xs text-gray-500">
                            ({formatNumber(item?.qty * item?.price * rateUsdt)}đ)
                          </span>
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* Tổng tiền */}
              <div className="lg:col-span-4">
                <div className="bg-white shadow rounded-lg p-4 space-y-3">
                  <table className="w-full text-sm border">
                    <tbody>
                      <tr className="border-b">
                        <td className="p-2 font-medium">Sản phẩm</td>
                        <td className="p-2 text-right">
                          <img src="/images/logoToken.png" className="w-5 inline" />{" "}
                          {Number(order?.itemsPrice)?.toFixed(2)}{" "}
                          <span className="text-xs text-gray-500">
                            ({formatNumber(order?.itemsPrice * rateUsdt)}đ)
                          </span>
                        </td>
                      </tr>
                      <tr className="border-b">
                        <td className="p-2 font-medium">Phí vận chuyển</td>
                        <td className="p-2 text-right">
                          <img src="/images/logoToken.png" className="w-5 inline" />{" "}
                          {(order?.shippingPrice + order?.taxPrice)?.toFixed(2)}{" "}
                          <span className="text-xs text-gray-500">
                            ({formatNumber((order?.shippingPrice + order?.taxPrice) * rateUsdt)}đ)
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2 font-medium">Tổng cộng</td>
                        <td className="p-2 text-right font-semibold">
                          <img src="/images/logoToken.png" className="w-5 inline" />{" "}
                          {order?.totalPrice?.toFixed(2)}{" "}
                          <span className="text-xs text-gray-500">
                            ({formatNumber(order?.totalPrice * rateUsdt)}đ)
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {order?.paymentMethod === "now" && !order?.isPaid && <VietQRGenerator order={order} />}

                  {!order.isPaid && (
                    <div>
                      {loadingPay && <Loading />}
                      {!sdkReady ? (
                        <Loading />
                      ) : (
                        <PayPalButtons amount={order?.totalPrice} onSuccess={successPaymentHandler} />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>

    </div>
  );
};

export default OrderScreen;

